module.exports = __webpack_public_path__ + "media/images/sample/theme_1-c8a3ddb5760c93cecf3ce6ec6627efac.png";